<template>
  <div class="tw:h-full tw:flex tw:flex-col">
    <EdroneNavigationTop type="drawer" @close="$emit('back')">
      <template #header>
        <div class="tw:flex tw:flex-col tw:w-full">
          <EdroneHeader :title="trans._freemium.pricingTiers.title" type="h2" />
        </div>
      </template>
    </EdroneNavigationTop>
    <div class="tw:flex-1 tw:overflow-y-auto tw:p-6">
      <EdroneTable v-if="priceTiers.length">
        <thead class="tw:bg-default-000">
          <tr>
            <th>{{ trans._freemium.pricingTiers.table.price }}</th>
            <th>{{ trans._freemium.pricingTiers.table.contacts }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tier in priceTiers" :key="tier.price">
            <td>{{ tier.price }} {{ currency }}</td>
            <td>{{ tier.fromUnits || 0 }} {{ tier.upToUnits ? `- ${tier.upToUnits}` : "+" }}</td>
          </tr>
        </tbody>
      </EdroneTable>
      <EdroneResultState v-else class="tw:max-w-[75%] tw:mx-auto">
        <h3 class="tw:heading-2 tw:mb-1">{{ trans._freemium.pricingTiers.error.title }}</h3>
        <p class="body-2 tw:!text-default-700 tw:mb-4">
          {{ trans._freemium.pricingTiers.error.description }}
        </p>
      </EdroneResultState>
    </div>
    <EdroneNavigationBottom>
      <template #start>
        <EdroneButton type="text" @click="emit('back')">
          {{ trans["Back"] }}
        </EdroneButton>
      </template>
    </EdroneNavigationBottom>
  </div>
</template>

<script setup lang="ts">
import { DTOTierPrice } from "vue-app/api/dto.d";
import { COUNTRY_ID } from "vue-app/types/enums.ts";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneNavigationBottom from "edrone-components/EdroneNavigationBottom.vue";
import EdroneNavigationTop from "edrone-components/EdroneNavigationTop.vue";
import EdroneResultState from "edrone-components/EdroneResultState.vue";
import EdroneTable from "edrone-components/EdroneTable.vue";

interface Emits {
  (event: "back"): void;
}

defineProps<{
  priceTiers: DTOTierPrice[];
}>();

const emit = defineEmits<Emits>();

const currency =
  !window.EDRONE_CONTEXT.tracker.countryId || window.EDRONE_CONTEXT.tracker.countryId === COUNTRY_ID.POLAND
    ? "PLN"
    : window.EDRONE_CONTEXT.tracker.countryId === COUNTRY_ID.BRAZIL
    ? "BRL"
    : "EUR";
</script>
